import { BILLING_API } from '@Constants/backendConstants';
import { useLogger, useSynqoHttp } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

interface InvoiceCreationOptions {
    order_ids: string[];
}

export function useCreateInvoices() {
    const { info } = useLogger();
    const { post } = useSynqoHttp(`${BILLING_API}/invoices:generate.v1`);

    const { mutateAsync: startBatchProcess, isPending: isInvoiceCreationPending } = useMutation({
        mutationFn: (options: InvoiceCreationOptions) => post<undefined, InvoiceCreationOptions>('', options),
    });

    const createInvoices = useCallback(
        (selectedOrderIds: string[]) => {
            info(`Started invoice creation for ${selectedOrderIds.length} orders`);
            return startBatchProcess({
                order_ids: selectedOrderIds,
            });
        },
        [info, startBatchProcess],
    );

    return {
        createInvoices,
        isInvoiceCreationPending,
    };
}
